import {ConfirmationDialog, FormDialog, name} from '@management-ui/core';
import {Add, Delete, Edit} from '@mui/icons-material';
import {IconButton, Tooltip} from '@mui/material';
import * as React from 'react';
import {useCallback, useContext, useState} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Table from '../../../../components/Table';
import ContactPersonForm from '../../forms/ContactPersonForm';

const People = ({contact, onContactUpdated}) => {
  const services = useContext(ServiceContext);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDelete = useCallback((confirmed) => {
    setShowDelete(false);
    if (confirmed) {
      setLoading(true);
      services.contact.person.deletePerson(contact, selected).then(updated => {
        setLoading(false);
        onContactUpdated(updated);
      }).catch(() => setLoading(false));
    }
  }, [services, contact, selected, onContactUpdated]);

  return (
    <>
      <Table className={loading ? 'loading' : ''}>
        <Table.Actions>
          <h3>People</h3>
          <Tooltip title="Add New Person">
            <span>
              <IconButton
                onClick={() => setSelected(null) || setShowEdit(true)}
                disabled={contact.archived}>
                <Add/>
              </IconButton>
            </span>
          </Tooltip>
        </Table.Actions>
        <Table.Row>
          <Table.Header>Name</Table.Header>
          <Table.Header>Position</Table.Header>
          <Table.Header>Phone</Table.Header>
          <Table.Header>Email</Table.Header>
          <Table.Action/>
          <Table.Action/>
        </Table.Row>
        {contact.people.length > 0 ? (
          contact.people.map((person, index) => (
            <Table.Row key={index}>
              <Table.Column>
                {name(person)}
                {person.is_key ? <strong>&nbsp;(Key)</strong> : null}
                {person.is_accounts ? <strong>&nbsp;(Accounts)</strong> : null}
              </Table.Column>
              <Table.Column>{person.position ?? '-'}</Table.Column>
              <Table.Column>{person.phone ?? '-'}</Table.Column>
              <Table.Column>{person.email ?? '-'}</Table.Column>
              <Table.Action>
                <Tooltip title="Edit Person">
                  <span>
                    <IconButton
                      onClick={() => setSelected(person) || setShowEdit(true)}
                      disabled={contact.archived}>
                      <Edit/>
                    </IconButton>
                  </span>
                </Tooltip>
              </Table.Action>
              <Table.Action>
                <Tooltip title="Delete Person">
                  <span>
                    <IconButton
                      onClick={() => setSelected(person) || setShowDelete(true)}
                      disabled={contact.archived}>
                      <Delete/>
                    </IconButton>
                  </span>
                </Tooltip>
              </Table.Action>
            </Table.Row>
          ))
        ) : (
          <Table.NoRecords>There are no people associated with this contact</Table.NoRecords>
        )}
      </Table>
      <FormDialog
        title={selected ? 'Edit Person' : 'Add New Person'}
        open={showEdit}
        maxWidth="sm"
        onClose={() => setShowEdit(false)}
        render={(props) => (
          <ContactPersonForm
            {...props}
            contact={contact}
            person={selected ?? {}}
            onSaved={(updated) => setShowEdit(false) || onContactUpdated(updated)}
          />
        )}
      />
      <ConfirmationDialog
        title="Delete Person"
        message="Are you sure you want to delete this person?"
        open={showDelete}
        onClose={handleDelete}
      />
    </>
  );
};

export default People;
